/**
 * 金額の表示書式。
 *
 * API は NUMERIC を文字列で返す（浮動小数の誤差を持ち込まないため）。整数なら
 * 小数を出さず、端数があるときだけ 2 桁で出す。`12500.50` を `12,500.5` と
 * 出すと小数第 2 位が落ちたように見え、`1000` を `1,000.00` と出すのは
 * 見積書としてくどいため。
 */
export function formatAmount(value: string | number): string {
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n)) return String(value);
  return n.toLocaleString("ja-JP", {
    minimumFractionDigits: Number.isInteger(n) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}
